"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailsSection = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = require("lodash");
var react_1 = require("react");
var icons_1 = __importDefault(require("../../../assets/icons"));
var theme_1 = __importDefault(require("../../../styles/theme"));
var Icon_1 = require("../../atoms/Icon/Icon");
var IconButton_1 = require("../../atoms/IconButton/IconButton");
var TextIcon_1 = require("../../atoms/TextIcon/TextIcon");
var TextLink_1 = require("../../atoms/TextLink/TextLink");
var Typography_1 = require("../../atoms/Typography/Typography");
var AvatarStack_1 = require("../../molecules/AvatarStack/AvatarStack");
var ClipboardLink_1 = require("../../molecules/ClipboardLink/ClipboardLink");
var ExpandableTypography_1 = require("../../molecules/ExpandableTypography/ExpandableTypography");
var InfoIcon_1 = require("../../molecules/InfoIcon/InfoIcon");
var DetailsSection_static_1 = require("./DetailsSection.static");
var DetailsSection_style_1 = __importDefault(require("./DetailsSection.style"));
/**
 * DetailsSection organism
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/organisms-detailssection--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/organisms/DetailsSection Source}
 */
var DetailsSection = function (_a) {
    var rows = _a.rows, withBackground = _a.withBackground, className = _a.className;
    var classes = (0, DetailsSection_style_1.default)();
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)(classes.root, withBackground && classes.withBackground, className) }, { children: (0, lodash_1.map)(rows, function (row, index) { return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [renderLabelCell(row), renderValueCell(row), renderAvatarCell(row), renderEditCell(row)] }, "".concat(row.title).concat(index))); }) })));
    function renderLabelCell(_a) {
        var title = _a.title, icon = _a.icon, users = _a.users, pluralTitle = _a.pluralTitle, tooltip = _a.tooltip;
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.labelCell }, { children: [renderIcon(icon), (0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ variant: 'headline3', noWrap: true }, { children: (users && users.length !== 1) || pluralTitle ? pluralTitle || title + 's' : title })), tooltip && (0, jsx_runtime_1.jsx)(InfoIcon_1.InfoIcon, { className: classes.tooltip, tooltip: tooltip, isCompact: true })] })));
    }
    function renderIcon(icon) {
        if (!icon) {
            return null;
        }
        if ('path' in icon) {
            return (0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconPath: icon, color: theme_1.default.colors.grayIcon, className: classes.icon });
        }
        return icon;
    }
    function renderValueCell(_a) {
        var value = _a.value, valueAdditionalContent = _a.valueAdditionalContent, notAddedYet = _a.notAddedYet, numberOfLines = _a.numberOfLines, users = _a.users, avatarStack = _a.avatarStack;
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)(classes.valueCell, 'hoverable') }, { children: notAddedYet ? ((0, jsx_runtime_1.jsx)(TextIcon_1.TextIcon, { color: theme_1.default.colors.error, textColor: theme_1.default.colors.error, icon: icons_1.default.error, text: DetailsSection_static_1.localText.notAddedYet })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [value && value.text !== DetailsSection_static_1.localText.undefined ? (renderValue(value, numberOfLines, !users && !avatarStack)) : ((0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ color: theme_1.default.textColors.primaryLighter }, { children: DetailsSection_static_1.localText.notAddedYet }))), valueAdditionalContent] })) })));
    }
    function renderValue(_a, numberOfLines, showMore) {
        var clipboardLink = _a.clipboardLink, internalUrl = _a.internalUrl, externalUrl = _a.externalUrl, text = _a.text, textInNewLines = _a.textInNewLines;
        if (internalUrl) {
            return ((0, jsx_runtime_1.jsx)(TextLink_1.TextLink, __assign({ block: true, className: classes.valueTextWithoutIcon, url: internalUrl }, { children: text || internalUrl })));
        }
        if (externalUrl) {
            return ((0, jsx_runtime_1.jsx)(TextLink_1.TextLink, __assign({ url: externalUrl, tooltip: 'Open in New Tab', block: true, icon: icons_1.default.newTabCompact }, { children: text || externalUrl })));
        }
        if (clipboardLink) {
            return ((0, jsx_runtime_1.jsx)(ClipboardLink_1.ClipboardLink, __assign({ content: clipboardLink, icon: icons_1.default.clipboard }, { children: text || clipboardLink })));
        }
        var renderedText = (function () {
            if (Array.isArray(text)) {
                if (textInNewLines) {
                    return text.map(function (part, index) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.textLine }, { children: part }), index)); });
                }
                return text.join(' ');
            }
            return text;
        })();
        // Keep the div because content is wrapped in flex but ExpandableTypography renders two children whose positioning
        // will be affected by the flex of this component
        return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(ExpandableTypography_1.ExpandableTypography, __assign({ numberOfLines: numberOfLines || 3, className: (0, classnames_1.default)('plaintext', classes.valueTextWithoutIcon), showMore: showMore }, { children: renderedText })) }));
    }
    function renderAvatarCell(_a) {
        var users = _a.users, avatarStack = _a.avatarStack, onUsersClick = _a.onUsersClick, totalUsers = _a.totalUsers;
        if (users === null || users === void 0 ? void 0 : users.length) {
            return ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.avatarCell }, { children: (0, jsx_runtime_1.jsx)(AvatarStack_1.AvatarStack, { users: users, onClick: onUsersClick, total: totalUsers }) })));
        }
        if (avatarStack) {
            return (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.avatarCell }, { children: avatarStack }));
        }
        return null;
    }
    function renderEditCell(_a) {
        var edit = _a.edit;
        if (!edit) {
            return null;
        }
        return ((0, jsx_runtime_1.jsx)(IconButton_1.IconButton, { className: classes.editCell, icon: icons_1.default.edit, onClick: edit.onClick, isDisabled: !edit.mayEdit, tooltip: edit.mayEdit ? DetailsSection_static_1.localText.edit(edit.name) : DetailsSection_static_1.localText.noEditAccess(edit.name), withoutReservedPadding: true }));
    }
};
exports.DetailsSection = DetailsSection;
